<script lang="ts">
export const elBadgeColors = ['primary', 'secondary', 'red'] as const;
export type ElBadgeColors = (typeof elBadgeColors)[number];
</script>

<script lang="ts" setup>
defineProps<{
  value?: string;
  color: ElBadgeColors;
}>();
</script>

<template>
  <span
    class="absolute flex h-2 min-w-2 items-center justify-center overflow-hidden rounded-full p-[2px] text-[0.375rem] font-medium leading-4 text-white"
    :class="{
      'bg-primary-active': color === 'primary',
      'bg-secondary-active': color === 'secondary',
      'bg-red-500': color === 'red',
    }"
    >{{ value ?? '' }}</span
  >
</template>
